/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_GG_STORE_REPLY} from '../../constans';
import {headers} from '../../utils';
import {RSAA} from 'redux-api-middleware';
import queryString from 'query-string';
import {
    GAME_REQUEST,
    GAME_SUCCESS,
    GAME_FAILURE
} from "../../types";

const GameAction = (params = [], page = 1, limit = 20) => ({

    [RSAA]: {
        endpoint: () => {
            params.page = page;
            params.limit = limit;

            let query_param = queryString.stringify(params);
            return `${SERVER_GG_STORE_REPLY}/api/games?${query_param}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            GAME_REQUEST,
            {
                type: GAME_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": GAME_SUCCESS,
                        "actor": params.actor,
                        "id": 0,
                        "data": data,
                    }
                },
            },
            {
                type: GAME_FAILURE,
                payload: (action, state, res) => {
                    return res.json()
                },
            }
        ]
    }
});

export {GameAction}